import React from "react"

import { Input } from "components"
import { productUnitsSymbol } from "constant"
import classes from "./StrrdTableRow.module.scss"

const StrrdTableRow = (props) => {
  const { resolvedItem, setResolvedItems } = props

  const handleChange = (name, value) => {
    setResolvedItems(prev =>
      prev.map(ai =>
        ai.optionId === resolvedItem.optionId
          ? { ...ai, [name]: value }
          : ai
      )
    )
  }

  const numberType =
    resolvedItem.unit === "quantity" ? "int" : "float"

  const disabled =
    resolvedItem.receivedQuantity > resolvedItem.acceptedQuantity

  return (
    <tr>
      <td>
        {resolvedItem.foodName}{" "}
        {resolvedItem.isSimple ? "" : resolvedItem.foodOptionName}
      </td>
      <td style={{ textAlign: "center" }}>
        {resolvedItem.requestedQuantity}
        {productUnitsSymbol[resolvedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        {resolvedItem.acceptedQuantity}
        {productUnitsSymbol[resolvedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        {resolvedItem.receivedQuantity}
        {productUnitsSymbol[resolvedItem.unit]}
      </td>
      <td style={{ textAlign: "center" }}>
        <div className={classes["input-container"]}>
          <Input
            disabled={disabled}
            min={0}
            type="number"
            value={resolvedItem.returnedToDestinationQuantity}
            numberType={numberType}
            onChange={(e) => handleChange("returnedToDestinationQuantity", e.target.value)}
            className={classes["input"]}
          />
          <span>
            {productUnitsSymbol[resolvedItem.unit]}
          </span>
        </div>
      </td>
      <td style={{ textAlign: "center" }}>
        <div className={classes["input-container"]}>
          <Input
            disabled={disabled}
            min={0}
            type="number"
            value={resolvedItem.returnedToSourceQuantity}
            numberType={numberType}
            onChange={(e) => handleChange("returnedToSourceQuantity", e.target.value)}
            className={classes["input"]}
          />
          <span>
            {productUnitsSymbol[resolvedItem.unit]}
          </span>
        </div>
      </td>
      <td style={{ textAlign: "center" }}>
        <div className={classes["input-container"]}>
          <Input
            min={0}
            max={resolvedItem.receivedQuantity - resolvedItem.acceptedQuantity}
            type="number"
            disabled={!disabled}
            value={resolvedItem.reductionFromSourceQuantity}
            numberType={numberType}
            onChange={(e) => handleChange("reductionFromSourceQuantity", e.target.value)}
            className={classes["input"]}
          />
          <span>
            {productUnitsSymbol[resolvedItem.unit]}
          </span>
        </div>
      </td>
      <td style={{ textAlign: "center" }}>
        <div className={classes["input-container"]}>
          <Input
            disabled={disabled}
            min={0}
            type="number"
            value={resolvedItem.lossQuantity}
            numberType={numberType}
            onChange={(e) => handleChange("lossQuantity", e.target.value)}
            className={classes["input"]}
          />
          <span>
            {productUnitsSymbol[resolvedItem.unit]}
          </span>
        </div>
      </td>
    </tr>
  )
}

export default React.memo(StrrdTableRow)